<div
  class="relative flex flex-col w-full h-44 px-2 py-4 rounded border border-gray-400  justify-center items-center bg-white hover:bg-neutral-100 transition ease-in-out cursor-pointer"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="triggerFileInput()"
  [ngClass]="{'border-transparent outline-2 outline-gray-300 outline-dashed': isDragging, 
  'hover:bg-white cursor-auto': selectedBody,
  'opacity-50 cursor-not-allowed pointer-events-none': disabled
  }">
  <input
    type="file"
    #fileInput
    name="fileInput"
    [multiple]="multiple"
    [accept]="inputAccept"
    (change)="selectFile($event)"
    class="hidden" />

  <div class="flex flex-col w-full justify-start items-center gap-2" *ngIf="!selectedBody; else fileSelected">
    <div class="flex flex-col h-16 justify-center items-center">
      <img *ngIf="!selectedBody && !isLoading" class="pointer-events-none h-16" [src]="'../../../../assets/TechLife.png'" />
      <div class="flex w-full justify-center items-center" *ngIf="isLoading"><flow-spinner></flow-spinner></div>
    </div>
    <div class="flex-1 text-center">
      <span class="text-gray-900 text-center text-xs font-semibold leading-3">
        {{'createMedia.dropFiles' | translate}}
        <span *ngIf="title">{{ 'createMedia.or' | translate }}</span>
        <span class="text-brand-bright-orange text-center text-xs font-semibold underline leading-3 cursor-pointer">
          {{title | translate}}
        </span>
      </span>
      <div class="flex flex-col m-0 text-gray-800 text-center text-xs font-normal ">
        <span>{{ 'createMedia.supportsFileTypes' | translate:{ fileTypes: supportedFileTypeLabel } }}</span>
        <span *ngIf="isVideoSupported">{{'createMedia.videoRecommendedLength' | translate}}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #fileSelected>
  <img *ngIf="selectedBody?.format === MediaFormat.Image" class="w-fit h-full  rounded" [src]="selectedBody.filePreview" />

  <div class="flex relative w-full h-full items-center justify-center" *ngIf="selectedBody?.format === MediaFormat.Video">
    <app-icon
      stroke="#fff"
      fill="#202020"
      iconName="play-file"
      size="lg"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></app-icon>
    <img *ngIf="selectedBody.filePreview" class="w-fit h-full  rounded" [src]="selectedBody.filePreview" />
  </div>

  <div class="flex flex-col items-center gap-1" *ngIf="selectedBody?.format === MediaFormat.JSON">
    <app-icon iconName="json-icon" size="xl" fill="#598fae"></app-icon>
    <p>{{selectedBody.selectedFile.name}}</p>
  </div>

  <app-icon
    class="absolute top-2 right-2 cursor-pointer rounded-md transition ease-in-out bg-white hover:bg-gray-200"
    size="lg"
    iconName="close"
    (click)="resetSelectedFile($event)"></app-icon>
</ng-template>
